var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinimize = function SvgMinimize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4.747 6.161 6.424 6.425H5.807v2h7.779l1-1V5.808h-2v5.364L6.16 4.747zM19.768 26.546v-5.364l6.424 6.425 1.414-1.415-6.424-6.424h5.364v-2h-7.778l-1 1v7.778z"
  })));
};
export default SvgMinimize;